export const myBetsListItemDateFormat: string = ', MMMM dd, yyyy';
